// 出発地データ: 地域 → 国 → 主要都市 の階層。
// 各要素は日本語名 name と英語名 nameEn を持つ（ピッカーで日英併記表示）。
// 各都市: { name, nameEn, lat, lng, elevation?(海抜m≒ENU原点), lookAt? }
// リアルタイム Google 3D Tiles から、実際に「3Dビルのメッシュがある」都市だけを収録
// （各都市を3×3グリッドで実探査し、最細リーフ三角形数 maxTris>=700 を被覆と判定）。

export const REGIONS = [
  {
    name: "アジア", nameEn: "Asia", emoji: "🌏",
    countries: [
      {
        name: "日本", nameEn: "Japan", emoji: "🗾",
        cities: [
          { name: "東京", nameEn: "Tokyo", lat: 35.6812, lng: 139.7671, elevation: 10, lookAt: { lat: 35.6885, lng: 139.7543 } },
          { name: "大阪", nameEn: "Osaka", lat: 34.7025, lng: 135.495, elevation: 5 },
          { name: "名古屋", nameEn: "Nagoya", lat: 35.1706, lng: 136.8816, elevation: 10 },
          { name: "札幌", nameEn: "Sapporo", lat: 43.0686, lng: 141.3508, elevation: 17 },
          { name: "福岡", nameEn: "Fukuoka", lat: 33.5897, lng: 130.4207, elevation: 5 },
          // 出発地は広島駅。原爆ドームの真上だと輪の内側にスポーンしてしまうので離してある。
          { name: "広島", nameEn: "Hiroshima", lat: 34.3979, lng: 132.4757, elevation: 5, lookAt: { lat: 34.3955, lng: 132.4536 } },
          { name: "仙台", nameEn: "Sendai", lat: 38.2601, lng: 140.8819, elevation: 40 },
          { name: "釧路", nameEn: "Kushiro", lat: 42.9849, lng: 144.382, elevation: 5 },
          { name: "那覇", nameEn: "Naha", lat: 26.2146, lng: 127.689, elevation: 10 },
          { name: "静岡", nameEn: "Shizuoka", lat: 34.9756, lng: 138.3828 },
          { name: "横浜", nameEn: "Yokohama", lat: 35.466, lng: 139.6222 },
          { name: "神戸", nameEn: "Kobe", lat: 34.69, lng: 135.1956 },
          { name: "千葉", nameEn: "Chiba", lat: 35.6073, lng: 140.1063 },
          { name: "京都", nameEn: "Kyoto", lat: 35.0116, lng: 135.7681, elevation: 30 },
          // 金沢駅から兼六園へ。追加した名所の輪の再武装範囲を避ける。
          { name: "金沢", nameEn: "Kanazawa", lat: 36.5781, lng: 136.6478, elevation: 10, lookAt: { lat: 36.5621, lng: 136.6626 } },
          { name: "新潟", nameEn: "Niigata", lat: 37.9161, lng: 139.0364 },
          { name: "岡山", nameEn: "Okayama", lat: 34.6551, lng: 133.9195 },
          // 熊本駅から熊本城を目指す。
          { name: "熊本", nameEn: "Kumamoto", lat: 32.7897, lng: 130.6886, elevation: 10, lookAt: { lat: 32.8062, lng: 130.7059 } },
          { name: "鹿児島", nameEn: "Kagoshima", lat: 31.5966, lng: 130.5571 },
          { name: "奈良", nameEn: "Nara", lat: 34.6851, lng: 135.8048 },
          { name: "長崎", nameEn: "Nagasaki", lat: 32.7503, lng: 129.8779 },
        ],
      },
      {
        name: "香港", nameEn: "Hong Kong", emoji: "🇭🇰",
        cities: [
          { name: "中環", nameEn: "Central", lat: 22.282, lng: 114.1588, elevation: 3, lookAt: { lat: 22.276, lng: 114.146 } },
        ],
      },
      {
        name: "台湾", nameEn: "Taiwan", emoji: "🇹🇼",
        cities: [
          { name: "台北", nameEn: "Taipei", lat: 25.033, lng: 121.5654 },
          { name: "台中", nameEn: "Taichung", lat: 24.1477, lng: 120.6736 },
        ],
      },
      {
        name: "シンガポール", nameEn: "Singapore", emoji: "🇸🇬",
        cities: [
          { name: "マリーナベイ", nameEn: "Marina Bay", lat: 1.2834, lng: 103.8607, elevation: 5 },
        ],
      },
    ],
  },
  {
    name: "ヨーロッパ", nameEn: "Europe", emoji: "🌍",
    countries: [
      {
        name: "イギリス", nameEn: "United Kingdom", emoji: "🇬🇧",
        cities: [
          { name: "ロンドン", nameEn: "London", lat: 51.5074, lng: -0.1278, elevation: 11 },
          { name: "エディンバラ", nameEn: "Edinburgh", lat: 55.9533, lng: -3.1883 },
          { name: "マンチェスター", nameEn: "Manchester", lat: 53.4808, lng: -2.2426 },
          { name: "バーミンガム", nameEn: "Birmingham", lat: 52.4862, lng: -1.8904 },
          { name: "リバプール", nameEn: "Liverpool", lat: 53.4084, lng: -2.9916 },
          { name: "ブリストル", nameEn: "Bristol", lat: 51.4545, lng: -2.5879 },
          { name: "グラスゴー", nameEn: "Glasgow", lat: 55.8642, lng: -4.2518 },
        ],
      },
      {
        name: "アイルランド", nameEn: "Ireland", emoji: "🇮🇪",
        cities: [
          { name: "ダブリン", nameEn: "Dublin", lat: 53.3498, lng: -6.2603 },
        ],
      },
      {
        name: "フランス", nameEn: "France", emoji: "🇫🇷",
        cities: [
          // トロカデロ広場からエッフェル塔へ。輪から750m以上離して出発する。
          { name: "パリ", nameEn: "Paris", lat: 48.8636, lng: 2.2816, elevation: 60, lookAt: { lat: 48.8584, lng: 2.2945 } },
          { name: "ニース", nameEn: "Nice", lat: 43.7102, lng: 7.262 },
          { name: "マルセイユ", nameEn: "Marseille", lat: 43.2965, lng: 5.3698 },
          { name: "トゥールーズ", nameEn: "Toulouse", lat: 43.6047, lng: 1.4442, elevation: 146 },
          { name: "リヨン", nameEn: "Lyon", lat: 45.764, lng: 4.8357 },
          { name: "ストラスブール", nameEn: "Strasbourg", lat: 48.5734, lng: 7.7521 },
          { name: "ボルドー", nameEn: "Bordeaux", lat: 44.8378, lng: -0.5792 },
          { name: "リール", nameEn: "Lille", lat: 50.6292, lng: 3.0573 },
          { name: "ナント", nameEn: "Nantes", lat: 47.2184, lng: -1.5536 },
        ],
      },
      {
        name: "モナコ", nameEn: "Monaco", emoji: "🇲🇨",
        cities: [
          { name: "モナコ", nameEn: "Monte Carlo", lat: 43.7384, lng: 7.4246, elevation: 16 },
        ],
      },
      {
        name: "ドイツ", nameEn: "Germany", emoji: "🇩🇪",
        cities: [
          { name: "ベルリン", nameEn: "Berlin", lat: 52.52, lng: 13.405, elevation: 34 },
          { name: "ミュンヘン", nameEn: "Munich", lat: 48.1351, lng: 11.582, elevation: 520 },
          { name: "フランクフルト", nameEn: "Frankfurt", lat: 50.1109, lng: 8.6821 },
          // ライン川東岸のメッセ／ドイツ駅付近から大聖堂へ。
          { name: "ケルン", nameEn: "Cologne", lat: 50.9400, lng: 6.9750, elevation: 50, lookAt: { lat: 50.9413, lng: 6.9583 } },
          { name: "ハンブルク", nameEn: "Hamburg", lat: 53.5511, lng: 9.9937 },
          { name: "デュッセルドルフ", nameEn: "Düsseldorf", lat: 51.2277, lng: 6.7735 },
          { name: "シュトゥットガルト", nameEn: "Stuttgart", lat: 48.7758, lng: 9.1829, elevation: 247 },
          { name: "ドレスデン", nameEn: "Dresden", lat: 51.0504, lng: 13.7373 },
          { name: "ライプツィヒ", nameEn: "Leipzig", lat: 51.3397, lng: 12.3731 },
        ],
      },
      {
        name: "オランダ", nameEn: "Netherlands", emoji: "🇳🇱",
        cities: [
          { name: "アムステルダム", nameEn: "Amsterdam", lat: 52.3676, lng: 4.9041 },
          { name: "ロッテルダム", nameEn: "Rotterdam", lat: 51.9244, lng: 4.4777 },
          { name: "ハーグ", nameEn: "The Hague", lat: 52.0705, lng: 4.3007 },
          { name: "ユトレヒト", nameEn: "Utrecht", lat: 52.0907, lng: 5.1214 },
        ],
      },
      {
        name: "ベルギー", nameEn: "Belgium", emoji: "🇧🇪",
        cities: [
          { name: "ブリュッセル", nameEn: "Brussels", lat: 50.8503, lng: 4.3517 },
          { name: "アントワープ", nameEn: "Antwerp", lat: 51.2194, lng: 4.4025 },
          { name: "ヘント", nameEn: "Ghent", lat: 51.0543, lng: 3.7174 },
        ],
      },
      {
        name: "スイス", nameEn: "Switzerland", emoji: "🇨🇭",
        cities: [
          { name: "チューリッヒ", nameEn: "Zurich", lat: 47.3769, lng: 8.5417, elevation: 408 },
          { name: "ジュネーブ", nameEn: "Geneva", lat: 46.2044, lng: 6.1432, elevation: 375 },
          { name: "バーゼル", nameEn: "Basel", lat: 47.5596, lng: 7.5886, elevation: 260 },
          { name: "ベルン", nameEn: "Bern", lat: 46.948, lng: 7.4474, elevation: 540 },
          { name: "ローザンヌ", nameEn: "Lausanne", lat: 46.5197, lng: 6.6323, elevation: 495 },
        ],
      },
      {
        name: "オーストリア", nameEn: "Austria", emoji: "🇦🇹",
        cities: [
          { name: "ウィーン", nameEn: "Vienna", lat: 48.2082, lng: 16.3738, elevation: 190 },
          { name: "グラーツ", nameEn: "Graz", lat: 47.0707, lng: 15.4395, elevation: 353 },
          { name: "ザルツブルク", nameEn: "Salzburg", lat: 47.8095, lng: 13.055, elevation: 424 },
          { name: "インスブルック", nameEn: "Innsbruck", lat: 47.2692, lng: 11.4041, elevation: 574 },
        ],
      },
      {
        name: "イタリア", nameEn: "Italy", emoji: "🇮🇹",
        cities: [
          // 出発地はスペイン広場。コロッセオの真上だと輪の内側にスポーンしてしまう。
          { name: "ローマ", nameEn: "Rome", lat: 41.9058, lng: 12.4823, elevation: 30, lookAt: { lat: 41.8902, lng: 12.4922 } },
          { name: "ミラノ", nameEn: "Milan", lat: 45.4642, lng: 9.19 },
          { name: "ヴェネツィア", nameEn: "Venice", lat: 45.4408, lng: 12.3155 },
          // 出発地はミケランジェロ広場（市街を見下ろす展望地）。大聖堂の真上は避ける。
          { name: "フィレンツェ", nameEn: "Florence", lat: 43.7629, lng: 11.2650, elevation: 104, lookAt: { lat: 43.7731, lng: 11.2560 } },
          { name: "ナポリ", nameEn: "Naples", lat: 40.8518, lng: 14.2681 },
          { name: "トリノ", nameEn: "Turin", lat: 45.0703, lng: 7.6869 },
          { name: "ボローニャ", nameEn: "Bologna", lat: 44.4949, lng: 11.3426 },
          { name: "ジェノヴァ", nameEn: "Genoa", lat: 44.4056, lng: 8.9463 },
        ],
      },
      {
        name: "スペイン", nameEn: "Spain", emoji: "🇪🇸",
        cities: [
          { name: "マドリード", nameEn: "Madrid", lat: 40.4168, lng: -3.7038, elevation: 667 },
          { name: "バルセロナ", nameEn: "Barcelona", lat: 41.3851, lng: 2.1734, elevation: 12 },
          { name: "サンセバスチャン", nameEn: "San Sebastián", lat: 43.3183, lng: -1.9812, elevation: 5 },
          { name: "ビルバオ", nameEn: "Bilbao", lat: 43.263, lng: -2.935, elevation: 19 },
          { name: "バレンシア", nameEn: "Valencia", lat: 39.4699, lng: -0.3763, elevation: 15 },
          { name: "サラゴサ", nameEn: "Zaragoza", lat: 41.6488, lng: -0.8891, elevation: 200 },
          { name: "マラガ", nameEn: "Málaga", lat: 36.7213, lng: -4.4214 },
          { name: "セビリア", nameEn: "Seville", lat: 37.3891, lng: -5.9845 },
        ],
      },
      {
        name: "ポルトガル", nameEn: "Portugal", emoji: "🇵🇹",
        cities: [
          { name: "リスボン", nameEn: "Lisbon", lat: 38.7223, lng: -9.1393 },
          { name: "ポルト", nameEn: "Porto", lat: 41.1579, lng: -8.6291 },
          { name: "ファロ", nameEn: "Faro", lat: 37.0194, lng: -7.9304 },
        ],
      },
      {
        name: "ギリシャ", nameEn: "Greece", emoji: "🇬🇷",
        cities: [
          { name: "アテネ", nameEn: "Athens", lat: 37.9838, lng: 23.7275, elevation: 70 },
          { name: "テッサロニキ", nameEn: "Thessaloniki", lat: 40.6401, lng: 22.9444 },
        ],
      },
      {
        name: "ポーランド", nameEn: "Poland", emoji: "🇵🇱",
        cities: [
          { name: "ワルシャワ", nameEn: "Warsaw", lat: 52.2297, lng: 21.0122, elevation: 100 },
          { name: "クラクフ", nameEn: "Krakow", lat: 50.0647, lng: 19.945 },
          { name: "ポズナン", nameEn: "Poznań", lat: 52.4064, lng: 16.9252 },
          { name: "ヴロツワフ", nameEn: "Wrocław", lat: 51.1079, lng: 17.0385 },
          { name: "グダニスク", nameEn: "Gdańsk", lat: 54.352, lng: 18.6466 },
        ],
      },
      {
        name: "チェコ", nameEn: "Czech Republic", emoji: "🇨🇿",
        cities: [
          { name: "プラハ", nameEn: "Prague", lat: 50.0755, lng: 14.4378, elevation: 200 },
          { name: "ブルノ", nameEn: "Brno", lat: 49.1951, lng: 16.6068, elevation: 237 },
        ],
      },
      {
        name: "ハンガリー", nameEn: "Hungary", emoji: "🇭🇺",
        cities: [
          { name: "ブダペスト", nameEn: "Budapest", lat: 47.4979, lng: 19.0402, elevation: 102 },
          { name: "デブレツェン", nameEn: "Debrecen", lat: 47.5316, lng: 21.6273 },
        ],
      },
      {
        name: "ルーマニア", nameEn: "Romania", emoji: "🇷🇴",
        cities: [
          { name: "ブカレスト", nameEn: "Bucharest", lat: 44.4268, lng: 26.1025 },
          { name: "クルジュ=ナポカ", nameEn: "Cluj-Napoca", lat: 46.7712, lng: 23.6236, elevation: 340 },
        ],
      },
      {
        name: "クロアチア", nameEn: "Croatia", emoji: "🇭🇷",
        cities: [
          { name: "ザグレブ", nameEn: "Zagreb", lat: 45.815, lng: 15.9819, elevation: 122 },
        ],
      },
      {
        name: "デンマーク", nameEn: "Denmark", emoji: "🇩🇰",
        cities: [
          { name: "コペンハーゲン", nameEn: "Copenhagen", lat: 55.6761, lng: 12.5683 },
          { name: "オーフス", nameEn: "Aarhus", lat: 56.1629, lng: 10.2039 },
        ],
      },
      {
        name: "スウェーデン", nameEn: "Sweden", emoji: "🇸🇪",
        cities: [
          { name: "ストックホルム", nameEn: "Stockholm", lat: 59.3293, lng: 18.0686 },
          { name: "マルメ", nameEn: "Malmö", lat: 55.605, lng: 13.0038 },
          { name: "ヨーテボリ", nameEn: "Gothenburg", lat: 57.7089, lng: 11.9746 },
        ],
      },
      {
        name: "ノルウェー", nameEn: "Norway", emoji: "🇳🇴",
        cities: [
          { name: "オスロ", nameEn: "Oslo", lat: 59.9139, lng: 10.7522 },
          { name: "ベルゲン", nameEn: "Bergen", lat: 60.3913, lng: 5.3221 },
          { name: "トロンハイム", nameEn: "Trondheim", lat: 63.4305, lng: 10.3951 },
        ],
      },
      {
        name: "フィンランド", nameEn: "Finland", emoji: "🇫🇮",
        cities: [
          { name: "ヘルシンキ", nameEn: "Helsinki", lat: 60.1699, lng: 24.9384 },
          { name: "タンペレ", nameEn: "Tampere", lat: 61.4978, lng: 23.761 },
        ],
      },
      {
        name: "アイスランド", nameEn: "Iceland", emoji: "🇮🇸",
        cities: [
          { name: "レイキャビク", nameEn: "Reykjavik", lat: 64.1466, lng: -21.9426 },
        ],
      },
    ],
  },
  {
    name: "アフリカ", nameEn: "Africa", emoji: "🦁",
    countries: [
      {
        name: "チュニジア", nameEn: "Tunisia", emoji: "🇹🇳",
        cities: [
          { name: "チュニス", nameEn: "Tunis", lat: 36.8065, lng: 10.1815 },
        ],
      },
      {
        name: "南アフリカ", nameEn: "South Africa", emoji: "🇿🇦",
        cities: [
          { name: "ケープタウン", nameEn: "Cape Town", lat: -33.9249, lng: 18.4241, elevation: 25 },
          { name: "ヨハネスブルグ", nameEn: "Johannesburg", lat: -26.2041, lng: 28.0473, elevation: 1753 },
          { name: "プレトリア", nameEn: "Pretoria", lat: -25.7479, lng: 28.2293, elevation: 1339 },
          { name: "ダーバン", nameEn: "Durban", lat: -29.8587, lng: 31.0218 },
        ],
      },
    ],
  },
  {
    name: "北米", nameEn: "North America", emoji: "🌎",
    countries: [
      {
        name: "アメリカ", nameEn: "United States", emoji: "🇺🇸",
        cities: [
          { name: "ニューヨーク", nameEn: "New York", lat: 40.7128, lng: -74.006, elevation: 10 },
          { name: "ロサンゼルス", nameEn: "Los Angeles", lat: 34.0522, lng: -118.2437 },
          { name: "サンフランシスコ", nameEn: "San Francisco", lat: 37.7749, lng: -122.4194 },
          { name: "シカゴ", nameEn: "Chicago", lat: 41.8781, lng: -87.6298, elevation: 180 },
          { name: "ラスベガス", nameEn: "Las Vegas", lat: 36.1699, lng: -115.1398, elevation: 620 },
          { name: "ワシントンD.C.", nameEn: "Washington DC", lat: 38.9072, lng: -77.0369 },
          { name: "マイアミ", nameEn: "Miami", lat: 25.7617, lng: -80.1918 },
          { name: "シアトル", nameEn: "Seattle", lat: 47.6062, lng: -122.3321 },
          { name: "ヒューストン", nameEn: "Houston", lat: 29.7604, lng: -95.3698 },
          { name: "フィラデルフィア", nameEn: "Philadelphia", lat: 39.9526, lng: -75.1652 },
          { name: "ボストン", nameEn: "Boston", lat: 42.3601, lng: -71.0589 },
          { name: "デンバー", nameEn: "Denver", lat: 39.7392, lng: -104.9903, elevation: 1609 },
          { name: "アトランタ", nameEn: "Atlanta", lat: 33.749, lng: -84.388, elevation: 320 },
          { name: "ダラス", nameEn: "Dallas", lat: 32.7767, lng: -96.797 },
          { name: "フェニックス", nameEn: "Phoenix", lat: 33.4484, lng: -112.074, elevation: 331 },
          { name: "サンディエゴ", nameEn: "San Diego", lat: 32.7157, lng: -117.1611 },
          { name: "オースティン", nameEn: "Austin", lat: 30.2672, lng: -97.7431, elevation: 149 },
          { name: "ポートランド", nameEn: "Portland", lat: 45.5152, lng: -122.6784 },
          { name: "ナッシュビル", nameEn: "Nashville", lat: 36.1627, lng: -86.7816 },
          { name: "デトロイト", nameEn: "Detroit", lat: 42.3314, lng: -83.0458 },
          { name: "ニューオーリンズ", nameEn: "New Orleans", lat: 29.9511, lng: -90.0715 },
          { name: "ミネアポリス", nameEn: "Minneapolis", lat: 44.9778, lng: -93.265 },
          { name: "ピッツバーグ", nameEn: "Pittsburgh", lat: 40.4406, lng: -79.9959 },
          { name: "サンアントニオ", nameEn: "San Antonio", lat: 29.4241, lng: -98.4936 },
          { name: "ホノルル", nameEn: "Honolulu", lat: 21.3069, lng: -157.8583 },
        ],
      },
      {
        name: "カナダ", nameEn: "Canada", emoji: "🇨🇦",
        cities: [
          { name: "トロント", nameEn: "Toronto", lat: 43.6532, lng: -79.3832, elevation: 76 },
          { name: "バンクーバー", nameEn: "Vancouver", lat: 49.2827, lng: -123.1207 },
          { name: "モントリオール", nameEn: "Montreal", lat: 45.5017, lng: -73.5673 },
          { name: "オタワ", nameEn: "Ottawa", lat: 45.4215, lng: -75.6972 },
          { name: "カルガリー", nameEn: "Calgary", lat: 51.0447, lng: -114.0719, elevation: 1045 },
          // パレ駅付近から高台のシタデルを目指す。
          { name: "ケベックシティ", nameEn: "Quebec City", lat: 46.8174, lng: -71.2139, elevation: 10, lookAt: { lat: 46.8075, lng: -71.2075 } },
          { name: "エドモントン", nameEn: "Edmonton", lat: 53.5461, lng: -113.4938, elevation: 645 },
        ],
      },
      {
        name: "メキシコ", nameEn: "Mexico", emoji: "🇲🇽",
        cities: [
          // 出発地は独立記念塔（レフォルマ通り）。ソカロはテンプロ・マヨールに近すぎる。
          { name: "メキシコシティ", nameEn: "Mexico City", lat: 19.4270, lng: -99.1677, elevation: 2240, lookAt: { lat: 19.4346, lng: -99.1315 } },
          { name: "モンテレイ", nameEn: "Monterrey", lat: 25.6866, lng: -100.3161, elevation: 540 },
          { name: "グアダラハラ", nameEn: "Guadalajara", lat: 20.6597, lng: -103.3496, elevation: 1566 },
        ],
      },
    ],
  },
  {
    name: "南米", nameEn: "South America", emoji: "🌎",
    countries: [
      {
        name: "ブラジル", nameEn: "Brazil", emoji: "🇧🇷",
        cities: [
          { name: "リオデジャネイロ", nameEn: "Rio de Janeiro", lat: -22.9068, lng: -43.1729, elevation: 10 },
          { name: "サンパウロ", nameEn: "São Paulo", lat: -23.5505, lng: -46.6333, elevation: 760 },
          { name: "ブラジリア", nameEn: "Brasília", lat: -15.7975, lng: -47.8919, elevation: 1170 },
          { name: "クリチバ", nameEn: "Curitiba", lat: -25.4284, lng: -49.2733, elevation: 935 },
          { name: "ポルトアレグレ", nameEn: "Porto Alegre", lat: -30.0346, lng: -51.2177 },
          { name: "ベロオリゾンテ", nameEn: "Belo Horizonte", lat: -19.9167, lng: -43.9345, elevation: 852 },
          { name: "レシフェ", nameEn: "Recife", lat: -8.0476, lng: -34.877 },
          { name: "サルバドール", nameEn: "Salvador", lat: -12.9777, lng: -38.5016 },
        ],
      },
      {
        name: "アルゼンチン", nameEn: "Argentina", emoji: "🇦🇷",
        cities: [
          { name: "ブエノスアイレス", nameEn: "Buenos Aires", lat: -34.6037, lng: -58.3816 },
          { name: "ロサリオ", nameEn: "Rosario", lat: -32.9442, lng: -60.6505 },
        ],
      },
    ],
  },
  {
    name: "オセアニア", nameEn: "Oceania", emoji: "🦘",
    countries: [
      {
        name: "オーストラリア", nameEn: "Australia", emoji: "🇦🇺",
        cities: [
          // 出発地はオペラハウス。ハイド・パーク・バラックスに近すぎる位置は避ける。
          { name: "シドニー", nameEn: "Sydney", lat: -33.8568, lng: 151.2153, elevation: 5, lookAt: { lat: -33.8690, lng: 151.2124 } },
          { name: "メルボルン", nameEn: "Melbourne", lat: -37.8136, lng: 144.9631 },
          { name: "ブリスベン", nameEn: "Brisbane", lat: -27.4698, lng: 153.0251 },
          { name: "パース", nameEn: "Perth", lat: -31.9505, lng: 115.8605 },
          { name: "ゴールドコースト", nameEn: "Gold Coast", lat: -28.0167, lng: 153.4 },
          { name: "アデレード", nameEn: "Adelaide", lat: -34.9285, lng: 138.6007 },
          { name: "ニューカッスル", nameEn: "Newcastle", lat: -32.9283, lng: 151.7817 },
          { name: "ホバート", nameEn: "Hobart", lat: -42.8821, lng: 147.3272 },
          { name: "キャンベラ", nameEn: "Canberra", lat: -35.2809, lng: 149.13, elevation: 577 },
        ],
      },
      {
        name: "ニュージーランド", nameEn: "New Zealand", emoji: "🇳🇿",
        cities: [
          { name: "クイーンズタウン", nameEn: "Queenstown", lat: -45.0312, lng: 168.6626, elevation: 310 },
        ],
      },
    ],
  },
];
